<div
    class="stat-item position-relative"
    [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h5>
        {{ 'Daily_Production' | translate}}
    </h5>
    <div class="number lh-1 fw-medium">
        {{ '45.32' | cultural }} kWh
    </div>
    <span class="daxa-up-down-badge position-relative">
        <i class="material-symbols-outlined">
            trending_up
        </i>
        {{ '2.15' | cultural }}%
    </span>
    <div class="chart">
        <div id="crm_new_users_chart"></div>
        <div class="title d-block text-body">
            {{ 'This_Week' | translate }}
        </div>
    </div>
</div>